module.exports = __webpack_public_path__ + "src/assets/img/szst_sd_03@2x.055be93c.png";